import createIcon from '../../createIcon';

/**
 * @component @name Archive
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNTQgNS4yM0wxOS4xNSAzLjU1QzE4Ljg4IDMuMjEgMTguNDcgMyAxOCAzSDZDNS41MyAzIDUuMTIgMy4yMSA0Ljg0IDMuNTVMMy40NiA1LjIzQzMuMTcgNS41NyAzIDYuMDIgMyA2LjVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDE5QzIwLjEgMjEgMjEgMjAuMSAyMSAxOVY2LjVDMjEgNi4wMiAyMC44MyA1LjU3IDIwLjU0IDUuMjNaTTEyIDE3LjVMNi41IDEySDEwVjEwSDE0VjEySDE3LjVMMTIgMTcuNVpNNS4xMiA1TDUuOTMgNEgxNy45M0wxOC44NyA1SDUuMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Archive = createIcon('Archive', [
  [
    'path',
    {
      d: 'M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM12 17.5L6.5 12H10V10H14V12H17.5L12 17.5ZM5.12 5L5.93 4H17.93L18.87 5H5.12Z',
      key: '8n3k6p',
    },
  ],
]);

export default Archive;
